import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { FuseHorizontalNavigationComponent, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';
import { FooterType01Component } from 'app/layout/common/footer/footer-type01/footer-type01.component';
import { FooterType02Component } from 'app/layout/common/footer/footer-type02/footer-type02.component';
import { FooterComponent } from 'app/layout/common/footer/footer.component';
import { LanguagesComponent } from 'app/layout/common/languages/languages.component';
import { MessagesComponent } from 'app/layout/common/messages/messages.component';
import { NotificationsComponent } from 'app/layout/common/notifications/notifications.component';
import { QuickChatComponent } from 'app/layout/common/quick-chat/quick-chat.component';
import { SearchComponent } from 'app/layout/common/search/search.component';
import { ShortcutsComponent } from 'app/layout/common/shortcuts/shortcuts.component';
import { UserComponent } from 'app/layout/common/user/user.component';
import { TFMCartService } from 'app/mock-api/tfm-cart.service';
import { TFMService } from 'app/mock-api/tfm.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector     : 'enterprise-layout',
    templateUrl  : './enterprise.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [FuseLoadingBarComponent, NgIf, FuseVerticalNavigationComponent, MatButtonModule, MatIconModule, LanguagesComponent, FuseFullscreenComponent, SearchComponent, ShortcutsComponent, MessagesComponent, NotificationsComponent, UserComponent, FuseHorizontalNavigationComponent, RouterOutlet, QuickChatComponent,FooterType01Component,FooterType02Component,FooterComponent],
})
export class EnterpriseLayoutComponent implements OnInit, OnDestroy
{
    public view : any = {
        isClient : true,
        data: {
          cart: []
        },
        drawers: {
          review:{}
        }
      };
    public drawerMode: 'over' | 'side' | 'push' = 'push';
    
    isScreenSmall: boolean;
    navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService,
        private tfmService: TFMService,
        private _tfmCartService: TFMCartService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    /** Whether the current route is the search result screen (cart should show limited columns). */
    isSearchResultRoute(): boolean {
        return this._router.url.includes('search-results');
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) =>
            {
                if (this.view.isClient) {
                    this.tfmService.getDestinations().then((res:any) => {
                        // console.log(res);
                        var destinations = [];
                        res.forEach(x => {
                            destinations.push(
                                { id: x.id, title: x.name, type: "basic", icon: "", link: `/destination/${x.id}/${x.seo.alias}` }
                            ); 
                        });

                        // this.tfmService.getPages().then(res => {
                            
                        // });

                        this.view.pages = res;
                        // console.log("Get pages", this.view.pages.content);
                    
                        navigation.horizontal = [];
                        
                        if (this.view.site && this.view.site.profile && this.view.site.profile.heading) {
                            switch (this.view.site.profile.heading.menu) {
                                case 1: {
                                    navigation.horizontal.push(
                                        { id: "home", title: "Home", subtitle: "", type: "basic", icon: "", children: [], link: "/" },
                                        { id: "destinations", title: "Destinations", subtitle: "", type: "group", icon: "", children: destinations },
                                        { id: "about", title: "About", subtitle: "", type: "basic", icon: "", children: [], link: "/about-us" },
                                        { id: "contact", title: "Contact", subtitle: "", type: "basic", icon: "", children: [], link: "/contact" },
                                    );
                                    break;
                                }
                                case 2: {
                                    navigation.horizontal.push(
                                        { id: "home", title: "Home", subtitle: "", type: "basic", icon: "", children: [], link: "/" },
                                        { id: "about", title: "About", subtitle: "", type: "basic", icon: "", children: [], link: "about-us" },
                                        { id: "corporate-travel", title: "Corporate Travel", subtitle: "", type: "basic", icon: "", children: [], link: "corporate-travel" },
                                        { id: "leisure-travel", title: "Leisure Travel", subtitle: "", type: "basic", icon: "", children: [], link: "leisure-travel" },
                                        { id: "branches", title: "Members", subtitle: "", type: "basic", icon: "", children: [], link: "branches" },
                                        { id: "contact", title: "Contact", subtitle: "", type: "basic", icon: "", children: [], link: "contact" },
                                    );
                                    break;
                                }
                                case 3: {
                                    navigation.horizontal.push(
                                        { id: "home", title: "Home", subtitle: "", type: "basic", icon: "", children: [], link: "/" },
                                        { id: "about", title: "About", subtitle: "", type: "basic", icon: "", children: [], link: "/about-us" },
                                        { id: "world-cruises", title: "World Cruises", subtitle: "", type: "basic", icon: "", children: [], link: "/world-cruises" },
                                        { id: "gallery", title: "Gallery", subtitle: "", type: "basic", icon: "", children: [], link: "/gallery" },
                                        { id: "contact", title: "Contact", subtitle: "", type: "basic", icon: "", children: [], link: "/contact" },
                                    );
                                    break;
                                }
                                default: {
                                    //console.log('No matching case found for services');
                                }
                            }
                        }

                        this.navigation = navigation;
                        // console.log("This is a Navigation data :",this.navigation);
                    });
                }
                else {
                    this.navigation = navigation;
                }
                // this.navigation = navigation;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) =>
            {
                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
        this.tfmService.getSite().then(res => {
            this.view.site = res;
        }); 
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }
        toggleNavigationB2C(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
